import { FEATURE_FLAG_KEYS, SHOP_THEME_NAME } from 'shop-ui/constants';
import { GRID_LAYOUT_TYPE } from 'shop-ui/section/Grid/rules';
import { combineComponent } from 'shop-ui/tools/combineComponent';
import { createFooterKYC } from 'shop-ui/component/FooterKYC';
import { createMenu } from 'shop-ui/component/Menu';
import { createLogo } from 'app/shop-ui/component/Logo';
import i18n from '@shared/i18n';

export const footerLayoutStyleMap = {
    [SHOP_THEME_NAME.STORY]: {
        primaryGrid: {},
        menu: {
            [FEATURE_FLAG_KEYS.FONT_COLOR]: 'rgba(255, 255, 255, 1)',
        },
        kyc: {
            [FEATURE_FLAG_KEYS.FONT_COLOR]: 'rgba(131, 131, 131, 1)',
        },
    },
    [SHOP_THEME_NAME.WINDOW]: {
        primaryGrid: {},
        menu: {
            [FEATURE_FLAG_KEYS.FONT_COLOR]: 'rgba(255, 255, 255, 1)',
        },
        kyc: {
            [FEATURE_FLAG_KEYS.FONT_COLOR]: 'rgba(131, 131, 131, 1)',
        },
    },
    [SHOP_THEME_NAME.PORTAL]: {
        primaryGrid: {},
        menu: {
            [FEATURE_FLAG_KEYS.FONT_COLOR]: 'rgba(255, 255, 255, 1)',
        },
        kyc: {
            [FEATURE_FLAG_KEYS.FONT_COLOR]: 'rgba(131, 131, 131, 1)',
        },
    },
    [SHOP_THEME_NAME.MAGAZINE]: {
        primaryGrid: {},
        menu: {
            [FEATURE_FLAG_KEYS.FONT_COLOR]: 'rgba(255, 255, 255, 1)',
        },
        kyc: {
            [FEATURE_FLAG_KEYS.FONT_COLOR]: 'rgba(131, 131, 131, 1)',
        },
    },
};

export function createFooter(theme: SHOP_THEME_NAME = SHOP_THEME_NAME.STORY) {
    const logo = createLogo(
        {
            [FEATURE_FLAG_KEYS.READONLY_DEFAULT_IMAGE_URL]:
                '/static/page-editor-logo-component-default-white_v1.png',
        },
        {
            deletable: true,
        }
    );

    const footerMenu = createMenu(
        {},
        {
            [FEATURE_FLAG_KEYS.MENU_ALIGNMENT]: 'right',
            ...footerLayoutStyleMap[theme].menu,
        }
    );

    const footerKYC = createFooterKYC(footerLayoutStyleMap[theme].kyc);

    return combineComponent(
        i18n.gettext('頁尾'),
        [[[logo], [footerMenu]], [[footerKYC]]],
        {
            primaryGridType: GRID_LAYOUT_TYPE.SPLIT_V_2C,
            secondaryGridType: [GRID_LAYOUT_TYPE.SPLIT_H_2C, GRID_LAYOUT_TYPE.SPLIT_H_2C],
            primaryGridPresetStyle: {
                [FEATURE_FLAG_KEYS.MIN_HEIGHT]: '100px',
                [FEATURE_FLAG_KEYS.BACKGROUND_COLOR]: 'rgba(32, 32, 38, 1)',
                [FEATURE_FLAG_KEYS.GRID_GAP]: '10px',
                [FEATURE_FLAG_KEYS.FIXED_SCREEN_HEIGHT]: false,
                [FEATURE_FLAG_KEYS.PADDING_RIGHT]: '27px',
                [FEATURE_FLAG_KEYS.PADDING_LEFT]: '27px',
                [FEATURE_FLAG_KEYS.PADDING_TOP]: '65px',
                [FEATURE_FLAG_KEYS.PADDING_BOTTOM]: '65px',
                ...footerLayoutStyleMap[theme].primaryGrid,
            },
            secondaryGridPresetStyle: [
                {
                    [FEATURE_FLAG_KEYS.GRID_ALIGNMENT]: 'center',
                    [FEATURE_FLAG_KEYS.GRID_GAP]: '10px',
                    [FEATURE_FLAG_KEYS.GRID_COLUMN_1]: '0.1fr',
                    [FEATURE_FLAG_KEYS.GRID_COLUMN_2]: '0.9fr',
                },
                {
                    [FEATURE_FLAG_KEYS.GRID_ALIGNMENT]: 'center',
                    [FEATURE_FLAG_KEYS.GRID_GAP]: '10px',
                    [FEATURE_FLAG_KEYS.GRID_COLUMN_1]: '0.5fr',
                    [FEATURE_FLAG_KEYS.GRID_COLUMN_2]: '0.5fr',
                },
            ],
            shouldWrap: true,
            deletable: false,
        }
    );
}
